'use client';

import { ReactNode } from "react";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter";
import { SessionProvider } from "next-auth/react";
import { Session } from "next-auth";
import { ThemeProvider } from "@/app/contexts/theme-context";
import { CookieConsentProvider } from "@/app/contexts/cookie-consent-context";
import CookieConsent from "@/app/__to_be_integrated/_____components/cookie-consent/CookieConsent";
import FloatingEdgeMenu from "@/app/__to_be_integrated/_____components/floating-edge-menu/FloatingEdgeMenu";
import "@/app/lib/date/init-luxon";
import { ApolloWrapper } from "@/app/lib/graphql/apollo/ApolloClient.client";
import { ToastContainer } from "react-toastify";
import { HeaderHeightVar } from "@/app/__to_be_integrated/_____components/_NEW/HeaderHeightVar";

export default function Providers({ children, session }: Readonly<{ children: ReactNode, session: Session | null }>) {

    return (
        <SessionProvider session={session}>
            <AppRouterCacheProvider>
                <ThemeProvider>
                    <CookieConsentProvider>
                        <ApolloWrapper>
                            {/*<HeaderProviderWrapper>*/}
                                {children}
                                <HeaderHeightVar />
                                <FloatingEdgeMenu />
                                <CookieConsent />
                                <ToastContainer position="bottom-center" autoClose={8000}/>
                            {/*</HeaderProviderWrapper>*/}
                        </ApolloWrapper>
                    </CookieConsentProvider>
                </ThemeProvider>
            </AppRouterCacheProvider>
        </SessionProvider>
    )
}
